import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { WalletFilterType } from "@/shared/repository/modules/wallet/enums";
import { WalletListResponse } from "@/shared/repository/modules/wallet/repo";
import { AdminCurrencyType } from "@/shared/repository/modules/admin/currency/enums";
import { formatAmountByPrecision } from "@/shared/utils/amount-helpers";
import { SvgAttribute } from "@/shared/constants/constants";
import { SVG } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      wallets: <WalletListResponse[]>[],
      error: false,
    };
  },
  async created(): Promise<void> {
    await this.loadBalances();
  },
  computed: {
    displayedSvg(): SvgAttribute {
      return SVG;
    },
    AdminCurrencyType() {
      return AdminCurrencyType;
    },

    displayedColumns(): Array<{
      id: number;
      label: string;
      isCurrency: boolean;
      isAmount: boolean;
    }> {
      return [
        {
          id: 0,
          label: "Валюта",
          isCurrency: true,
          isAmount: false,
        },
        {
          id: 1,
          label: "Всего",
          isCurrency: false,
          isAmount: true,
        },
      ];
    },
  },
  methods: {
    async loadBalances(): Promise<void> {
      try {
        this.isLoading = true;
        this.error = false;

        const wallets = await this.$projectServices.walletRepository.list(
          WalletFilterType.all,
          this.id
        );

        this.wallets = wallets;
      } catch (error) {
        console.error("Error loading balances:", error);
        this.error = true;
      } finally {
        this.isLoading = false;
      }
    },

    formatAmount(amount: number, precision: number): string {
      return formatAmountByPrecision(amount, precision);
    },
  },
});
